const eligibilityCriteriaActions = {
    GET_ELIGIBILITY_CRITERIA: 'GET_ELIGIBILITY_CRITERIA',
    SET_ELIGIBILITY_CRITERIA: 'SET_ELIGIBILITY_CRITERIA',

    CREATE_ELIGIBILITY_CRITERIA: 'CREATE_ELIGIBILITY_CRITERIA',
    UPDATE_ELIGIBILITY_CRITERIA: 'UPDATE_ELIGIBILITY_CRITERIA',

    SET_ACTIVE_ELIGIBILITY: 'SET_ACTIVE_ELIGIBILITY',

};

export default eligibilityCriteriaActions;